import { Position } from 'geojson';
import { atomFamily, selectorFamily } from 'recoil';
import { MultipleDevice } from '../types/device';

export const multipleDeviceState = atomFamily<MultipleDevice | undefined, string>({
  key: 'app.multipleDevices',
  default: undefined,
});

export const multipleDevicesLngLatsState = selectorFamily<Position[], string>({
  key: 'app.multipleDevicesLngLatsState',
  get:
    (assetId) =>
    ({ get }) => {
      const multipleDevices = get(multipleDeviceState(assetId));
      if (!multipleDevices?.devices?.length) return [];
      return multipleDevices.devices.map((multipleDevice) => [
        multipleDevice.position_longitude,
        multipleDevice.position_latitude,
      ]);
    },
});
